import { render, staticRenderFns } from "./Twitter.vue?vue&type=template&id=c1d0b73e&scoped=true&"
import script from "./Twitter.vue?vue&type=script&lang=js&"
export * from "./Twitter.vue?vue&type=script&lang=js&"
import style0 from "./Twitter.scss?vue&type=style&index=0&id=c1d0b73e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1d0b73e",
  null
  
)

export default component.exports